import { DP_DASHBOARD_TOGGLE_OPTIONS } from '../constants/dp.constant';
var getTabFromHash = function (hash) {
    var parts = hash.split('#');
    return parts.length > 2 ? parts[2] : null;
};
var getInitialToggleOption = function () {
    var hash = window.location.hash;
    var tabValue = getTabFromHash(hash);
    var validOption = DP_DASHBOARD_TOGGLE_OPTIONS.find(function (opt) { return opt.value === tabValue; });
    return validOption ? validOption.value : DP_DASHBOARD_TOGGLE_OPTIONS[0].value;
};
export { getTabFromHash, getInitialToggleOption };
